import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ChecklistItemModel } from 'src/app/ViewModel/ChecklistItemModel';
import { ChecklistModel, CopyChecklistModel } from 'src/app/ViewModel/ChecklistModel';
import { RestApiService } from '../rest-api.service';

@Injectable({
	providedIn: 'root'
})
export class ChecklistService {

	private readonly getChecklistUrl = 'Checklist/GetChecklists';
	private readonly getChecklistItemUrl = 'Checklist/GetChecklistItems';
	private readonly postChecklistUrl = 'Checklist/PostChecklist';
	private readonly PostCopyChecklist = 'Checklist/PostCopyChecklist';
	private readonly postChecklistItemUrl = 'Checklist/PostChecklistItem';

	public checklistId: BehaviorSubject<number|null> = new BehaviorSubject<number|null>(null);

	constructor(
		public restApiService: RestApiService,
	) { }


	getChecklist(groupId: number|null, disciplineId: number|null, buId: number|null, icId: number|null, projectId: number|null, isActive: boolean = false, isForWorkflow: boolean = false, isShowICSpecific: boolean = false): Observable<ChecklistModel[]> {
		let reqData:any = {
			'clId': null,
			groupId,
			disciplineId,
			buId,
			icId,
			projectId,
			isActive,
			isForWorkflow,
			isShowICSpecific
		}
		return this.restApiService.new_POST(this.getChecklistUrl, reqData);
	}

	getChecklistItem(clId: number): Observable<ChecklistItemModel[]> {
		return this.restApiService.new_POST(this.getChecklistItemUrl, { clId });
	}

	postChecklist(newChecklist: ChecklistModel) {
		return this.restApiService.new_POST(this.postChecklistUrl, newChecklist);
	}

	postChecklistItem(newChecklistItem: ChecklistItemModel) {
		return this.restApiService.new_POST(this.postChecklistItemUrl, newChecklistItem);
	}
	postcopyChecklist(newChecklist: CopyChecklistModel) {
		return this.restApiService.new_POST(this.PostCopyChecklist, newChecklist);
	}
}
